import React, { Component } from "react";
import Axios from "axios";
import { animated, Spring } from 'react-spring'
import VisibilitySensor from "react-visibility-sensor";
import Select from 'react-select'
import ReCAPTCHA from "react-google-recaptcha";
import { TelephoneFill, EnvelopeFill } from 'react-bootstrap-icons';

const grecaptchaObject = window.grecaptcha;
const country_list = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua &amp; Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia &amp; Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Cape Verde", "Cayman Islands", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica", "Cote D Ivoire", "Croatia", "Cruise Ship", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyz Republic", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre &amp; Miquelon", "Samoa", "San Marino", "Satellite", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "South Africa", "South Korea", "Spain", "Sri Lanka", "St Kitts &amp; Nevis", "St Lucia", "St Vincent", "St. Lucia", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad &amp; Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks &amp; Caicos", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"];





var options = [];
country_list.forEach(element => {
	options.push({ value: element, label: element })
});



const customStyles = {
	option: (provided, state) => ({
		...provided,
		color: "#000",
		fontFamily: "'Open Sans', sans-serif",
		fontSize: '15px'
	}),
	control: (provided, state) => ({
		...provided,
		backgroundColor: "transparent !important",
		color: "#5a5a5a !important",
		fontFamily: "'Open Sans', sans-serif",
		fontSize: '15px'
	}),
	singleValue: (provided, state) => ({
		...provided,
		backgroundColor: "transparent !important",
		color: "#5a5a5a !important",
		fontFamily: "'Open Sans', sans-serif",
		fontSize: '15px'
	})

}




class ContactUs extends Component {

	constructor(props) {
		super(props);
		this.state = {
			name: "",
			email: "",
			business_name: "",
			country: "",
			subject: "",
			message: "",
			hear_about: "",

			showHearAboutOtherField: false,
			other_hear: "",

			captchaValue: null,

			submitting: false,
			submitted: false,
		};




	}



	render() {
		return (
			<div className="row contact-us-div justify-content-center ">
				<div className="col-sm-12 pt-5 d-flex justify-content-center align-items-center">
					<VisibilitySensor >
						{({ isVisible }) => (
							<animated.div >
								<Spring
									from={{ opacity: isVisible ? 0 : 1 }}
									to={{ opacity: isVisible ? 1 : 1 }}
									config={{ duration: 0 }}
									delay={0}
								>

									{props => {
										return (
											<animated.div style={props}>

												<h1 className="h1Class" style={{ fontSize: "3rem" }}>
													{window.locale.translate('Contact Us')}
												</h1>

											</animated.div>
										)
									}}
								</Spring>
							</animated.div>
						)}
					</VisibilitySensor >
				</div>
				<div className="col-12">
					<div className="row justify-content-center">
						<div className="col-sm-3">
							<hr className="features-hr" />
						</div>
					</div>
				</div>

				<div className="col-sm-12 col-md-6 pt-5">
					<div className="contact-us-div-1">
						{this.state.submitted ? (
							<div className="justify-content-center text-center">
								<h2 className="mt-3">Thank you for contacting us.</h2>
								<h6 className="mt-3">We will get back to you within 24 hours on your email.</h6>
								<h5 className="mt-5">Wish you a good day ahead !</h5>
							</div>
						) : (
							<form>
								<div className="form-group">
									<input
										type="text"
										className="form-control"
										name="name"
										placeholder="Full Name"
										onChange={this.ChangeHandler}
									/>
								</div>

								<div className="form-group">
									<input
										type="email"
										name="email"
										className="form-control"
										placeholder="Email Address"
										onChange={this.ChangeHandler}
									/>
								</div>
								<div className="form-group">
									<input
										type="text"
										name="business_name"
										className="form-control"
										placeholder="Company Name"
										onChange={this.ChangeHandler}
									/>
								</div>
								<div className="form-group">
									<Select options={options}
										placeholder="Country"
										styles={customStyles}
										name="country"
										onChange={this.CountryChangeHandler}
									/>
								</div>
								<div className="form-group">
									<input
										type="text"
										className="form-control"
										name="subject"
										placeholder="Subject"
										onChange={this.ChangeHandler}
									/>
								</div>


								<div className="form-group">
									<textarea
										className="form-control"
										name="message"
										rows="5"
										placeHolder="Message"
										onChange={this.ChangeHandler}
									></textarea>
								</div>



								<div className="form-group">
									<b> How did you hear about us ? </b>
									<div className="mt-3 mb-5 radiobuttons">
										<div class="form-check">
											<input type="radio" className="form-check-input" id="radio1" name="optradio" value="Search Engines" onClick={this.radioChangeHandler} /> Search Engine (Google, Yahoo etc.)
											<label class="form-check-label" for="radio1"></label>
										</div>
										<div class="form-check">
											<input type="radio" className="form-check-input" id="radio1" name="optradio" value="Referral" onClick={this.radioChangeHandler} /> Referral
											<label class="form-check-label" for="radio1"></label>
										</div>
										<div class="form-check">
											<input type="radio" className="form-check-input" id="radio1" name="optradio" value="Online Publication" onClick={this.radioChangeHandler} /> Online Publication
											<label class="form-check-label" for="radio1"></label>
										</div>
										<div class="form-check">
											<input type="radio" className="form-check-input" id="radio1" name="optradio" value="Other" onClick={this.radioChangeHandler} /> Other
											<label class="form-check-label" for="radio1"></label>
										</div>
										{this.state.showHearAboutOtherField ?
											<div class="mt-3 w-50">
												<input
													type="text"
													className="form-control"
													name="other_hear"
													placeholder="How did you hear about us ?"
													onChange={this.ChangeHandler}
												/>
											</div>
											: ""
										}
									</div>
								</div>



								<div className="form-group text-center justify-content-center">
									<ReCAPTCHA
										sitekey="6LdV0u8lAAAAALfY44uq8Dh4r_oxuqF8tkTSCoQi"
										//grecaptcha={grecaptchaObject}
										onChange={this.onChangeCaptcha}
									/>
								</div>


								<div className="form-group justify-content-center">
									{this.state.submitting ? (
										<div class="spinner-border" role="status">
											<span class="sr-only">Loading...</span>
										</div>
									) : (
										<button
											style={{ width: "20%" }}
											type="button"
											className=" btn contact-us-submit-button w-100"
											onClick={this.submitForm}
										>
											Submit
										</button>
									)}
								</div>
							</form>
						)}
					</div >
				</div >


				<div className="col-sm-10 col-md-6 pt-5  text-center"  >
					<div className="contact-us-div-2">
						<VisibilitySensor partialVisibility={true} >
							{({ isVisible }) => (
								<animated.div >
									<Spring
										from={{ opacity: isVisible ? 0 : 1 }}
										to={{ opacity: isVisible ? 1 : 0 }}
										config={{ duration: !isVisible ? 0 : 2000 }}
									>

										{props => {
											return (
												<animated.div style={props}>

													<h3>Address </h3>
													<hr className="features-hr" />

													<p className="" >
														8 Leopold street <br />
														Strathtulloh<br />
														Vic-3338<br />
														Australia<br />
													</p>


												</animated.div>
											)
										}}
									</Spring>
								</animated.div>
							)}
						</VisibilitySensor >

						<VisibilitySensor partialVisibility={true} >
							{({ isVisible }) => (
								<animated.div >
									<Spring
										from={{ opacity: isVisible ? 0 : 1 }}
										to={{ opacity: isVisible ? 1 : 0 }}
										config={{ duration: !isVisible ? 0 : 2000 }}
									>

										{props => {
											return (
												<animated.div style={props}>

													<h3 className="mt-5">Contact </h3>
													<hr className="features-hr" />
													<a href="mailto:contact@edistillery.com.au" className="w-auto">
														<p className="contact-us-email-address"> <EnvelopeFill className="mr-2" /> contact@edistillery.com.au</p>
													</a>
													<p className="call-us" > <TelephoneFill className="mr-2" />  +61 450 132 363</p>

												</animated.div>
											)
										}}
									</Spring>
								</animated.div>
							)}
						</VisibilitySensor >





						<div className="mt-5">
							<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3155.379015584748!2d144.60179107596502!3d-37.734251567588785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad6929c4e9d0def%3A0xb469abaab71d98c!2s8%20Leopold%20St%2C%20Strathtulloh%20VIC%203338!5e0!3m2!1sen!2sau!4v1682906087105!5m2!1sen!2sau" width="400" height="300" style={{ border: '0', width: "100%" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
						</div>





					</div>
				</div>


			</div>
		);
	}

	ChangeHandler = (event) => {
		let nam = event.target.name ?? event.label;
		let val = event.target.value ?? event.value;
		this.setState({ [nam]: val });
	};


	radioChangeHandler = (event) => {
		if (event.target.value == "Other") {
			this.setState({ showHearAboutOtherField: true })
		} else {
			this.setState({
				showHearAboutOtherField: false,
				hear_about: event.target.value
			});
		}
	};


	CountryChangeHandler = (event) => {
		this.setState({ country: event.value });
	};



	onChangeCaptcha = (value) => {
		this.setState({ captchaValue: value });
	}

	validateEmail = () => {
		const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(this.state.email).toLowerCase());
	};

	submitForm = () => {
		/*****validation *******/
		if (this.state.name == "") {
			alert("Name cannot be empty");
			return;
		}
		if (this.state.email == "") {
			alert("Email cannot be empty");
			return;
		}
		if (this.state.business_name == "") {
			alert("Company name cannot be empty");
			return;
		}
		if (this.state.country == "") {
			alert("Please select your country");
			return;
		}
		if (this.state.subject == "") {
			alert("Subject cannot be empty");
			return;
		}
		if (this.state.message == "") {
			alert("Message cannot be empty");
			return;
		}

		if (!this.state.captchaValue) {
			alert("Please verify that you are not a bot");
			return;
		}


		if (!this.validateEmail()) {
			alert("Invalid email address");
			return;
		}



		if (!this.state.showHearAboutOtherField && this.state.hear_about == "") {
			alert("Please tell us how did you hear about this")
			return
		}


		if (this.state.showHearAboutOtherField && this.state.other_hear == "") {
			alert("Please tell us how did you hear about this")
			return
		}
		/*****validation *******/

		this.setState({
			submitting: true,
		});

		const comp = this;

		Axios.get("https://app.edistillery.com.au/web/contactus", {
			params: {
				name: comp.state.name,
				email: comp.state.email,
				business_name: comp.state.business_name,
				country: comp.state.country,
				subject: comp.state.subject,
				message: comp.state.message,
				hear_about: comp.state.showHearAboutOtherField ? comp.state.other_hear : comp.state.hear_about
			},
		})
			.then(function (response) {
				comp.setState({
					submitting: false,
					submitted: true,
				});
			})
			.catch(function (err) {
				comp.setState({
					submitting: false,
					submitted: false,
				});
				alert(
					"Error sending ! Please check your internet connection or try again later"
				);
			});
	};
}

export default ContactUs;
